import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import "./FaqSection.css";

const FAQS = [
  {
    q: "Kell hozzá alkalmazás letöltés?",
    a: "Nem. A Tablify böngészőben fut, mind a vendégek, mind a munkatársaid oldalán — nincs szükség telepítésre.",
  },
  {
    q: "Mennyi idő alatt állítható be?",
    a: "Az étterem és az első menü néhány perc alatt beállítható, utána már ki is helyezheted a QR kódokat az asztalokra.",
  },
  {
    q: "Mi történik a próbaidőszak után?",
    a: "A 14 napos ingyenes próba után választhatsz előfizetést — bankkártya nélkül próbálhatod ki, és bármikor lemondhatod.",
  },
  {
    q: "Válthatok csomagot később?",
    a: "Igen, bármikor válthatsz a Lite, Basic és Pro csomagok között, ahogy éttermed növekszik.",
  },
  {
    q: "Több éttermem is lehet egy fiókban?",
    a: "Igen — a Pro csomaggal több éttermet is kezelhetsz egyetlen fiókból.",
  },
  {
    q: "Milyen fizetési módokat fogadtok el?",
    a: "Az előfizetést bankkártyával, biztonságos Stripe-fizetésen keresztül tudod rendezni.",
  },
  {
    q: "Mi történik, ha lemondom az előfizetést?",
    a: "Az előfizetésed a következő számlázási időszak végéig aktív marad, utána egyszerűen leáll — nincs rejtett díj.",
  },
  {
    q: "Mi van, ha segítségre van szükségem?",
    a: "Minden csomag tartalmaz ügyfélszolgálati támogatást — írj nekünk a kapcsolat oldalon keresztül.",
  },
];

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((item) => ({
    "@type": "Question",
    name: item.q,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.a,
    },
  })),
};

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);
  const prefersReducedMotion = useReducedMotion();

  return (
    <section className="landing-section landing-faq-section" id="faq">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      </Helmet>

      <h2 className="landing-section-title fade-up">Gyakori kérdések</h2>

      <motion.div
        className="landing-faq-list"
        initial={prefersReducedMotion ? false : { opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      >
        {FAQS.map((item, index) => {
          const isOpen = openIndex === index;
          return (
            <div className="landing-faq-item" key={item.q}>
              <button
                type="button"
                className="landing-faq-question"
                aria-expanded={isOpen}
                aria-controls={`faq-panel-${index}`}
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
              >
                {item.q}
                <span className={`landing-faq-icon${isOpen ? " open" : ""}`}>+</span>
              </button>

              <AnimatePresence initial={false}>
                {isOpen && (
                  <motion.div
                    id={`faq-panel-${index}`}
                    initial={prefersReducedMotion ? false : { height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={prefersReducedMotion ? undefined : { height: 0, opacity: 0 }}
                    transition={{ duration: 0.28, ease: [0.16, 1, 0.3, 1] }}
                    style={{ overflow: "hidden" }}
                  >
                    <p className="landing-faq-answer">{item.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          );
        })}
      </motion.div>
    </section>
  );
}

export default FaqSection;
